import React, { useCallback } from 'react';
import styles from './Toggle.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';

const Toggle = ({ id, size = 'medium', className, checked, onChange, disabled, onClick }) => {
  const { t } = useTranslation();

  const handleChange = useCallback(
    e => {
      if (disabled) return;

      const isCheckboxEvent = e && e.target && e.target.type === 'checkbox';

      if (isCheckboxEvent) {
        onChange(e);
        return;
      }

      // Normalize keyboard-triggered events to look like an input change
      onChange({ target: { checked: !checked } });
    },
    [disabled, onChange, checked]
  );

  const myRef = useAccessibleClick(handleChange);

  return (
    <div ref={myRef} tabIndex={0} aria-label={checked ? t('accessibility.unselect') : t('general.select')} className={cx(styles.container, className)}>
      <input
        tabIndex={-1}
        type="checkbox"
        name="checkbox"
        id={`checkbox-${id}`}
        className={styles.checkboxInput}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        onClick={onClick}
        aria-label={checked ? t('accessibility.unselect') : t('general.select')}
      />
      <label tabIndex={-1} aria-label={checked ? t('accessibility.unselect') : t('general.select')} htmlFor={`checkbox-${id}`} className={cx(styles.checkboxLabel, styles[size])} onClick={onClick} />
    </div>
  );
};

export default Toggle;
